// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cancellation-commonHeaderAdmin-BRlE7 {
	position: fixed !important;
}

.Cancellation-adminLayout-At1k2 {
	padding-top: 64px !important;
}

.Cancellation-box-NWSvC h2 {
	font-size: 21px;
	font-weight: 600;
}

.Cancellation-exportLink-CHliG {
	margin-bottom: -29px;
}

.Cancellation-blockCenter-g0bU3 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Cancellation-panelHeader-sGz4H {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Cancellation-currencyselect-r4AZS {
	width: 100%;
	margin-right: 0px;
}

.Cancellation-panelHeader-sGz4H {
	overflow: hidden;
	position: relative;
}

.Cancellation-mar0-pP43I {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Cancellation-blockCenter-g0bU3 {
		padding: 0px;
	}

	.Cancellation-panelHeader-sGz4H {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Cancellation-sideAdminPageWrapper-xgLgQ {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Cancellation-panelHeader-sGz4H {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Cancellation-table-h1PhV {
	display: table;
}

.Cancellation-tableRow-XqG6a {
	display: table-row;
}

.Cancellation-tableCell-B2c5t {
	display: table-cell;
	float: none;
}

.Cancellation-formGroup-lOzeg {
	margin-bottom: 6px;
}

.Cancellation-select-xvvFy {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Cancellation-noMargin-E4JnI {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Cancellation-exportLink-CHliG {
	padding-top: 10px;
	padding-right: 10px;
}

.Cancellation-labelTextNew-AcfP0 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Cancellation-displayInline-kaaHb {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Cancellation-btnUPdate-a_7Dl {
	display: inline-block;
}

.Cancellation-btnModalDelete-_UqCX {
	display: inline-block;
	margin-left: 15px;
}

.Cancellation-radioBtn-TVsOo {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Cancellation-backgroundImg-Ef6BG {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Cancellation-btnUPdate-a_7Dl {
		display: block;
		margin-bottom: 12px;
	}

	.Cancellation-btnModalDelete-_UqCX {
		display: block;
		margin-left: 0px;
	}

	.Cancellation-btnWidth-I8hFc {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Cancellation-bannerImageBg-mqyAj {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Cancellation-bannerDelete-socLD {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Cancellation-modalRoot-qdp3u {
	padding: 32px;
}

.Cancellation-modalBorderBottom-FrUl8 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Cancellation-logInModalBody-ue0YO {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Cancellation-exportSection-I54HR {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Cancellation-exportSectionGridSub-fXE64 {
	grid-template-columns: 50% 49% !important;
}

.Cancellation-exportText-lDuWp {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Cancellation-exportLinkImg-zPdu6 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Cancellation-vtrMiddle-rDCQU {
	vertical-align: middle;
}

.Cancellation-exportImg-FsF1V {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Cancellation-profileViewlabel-apfa5 {
	display: inline-block;
	width: 38%
}

.Cancellation-profileViewMainContent-oSOVi {
	display: inline-block;
	width: 62%;
}

.Cancellation-profileViewMain-Bnrxd {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Cancellation-profileViewInner-KA42s {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Cancellation-profileImageSection-SpIRa {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Cancellation-lastviewInner-w2m85 {
	padding: 10px;
}

.Cancellation-whyHostHoriLine-qB146 {
	margin: 30px 0;
}

.Cancellation-tableGrid-npJYu {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Cancellation-headingContent-STQHo {
	font-size: 18px;
	font-weight: 500;
}

.Cancellation-refundTextColor-vAJkI {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Cancellation-dividerLine-IhySD {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Cancellation-smallContent-ma_IC {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Cancellation-sideAdminPageWrapper-xgLgQ {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Cancellation-sideAdminPageWrapper-xgLgQ {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Cancellation-exportSection-I54HR {
		grid-template-columns: 100%;
	}

	.Cancellation-exportSectionGridSub-fXE64 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Cancellation-profileViewlabel-apfa5 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Cancellation-profileViewMainContent-oSOVi {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Cancellation-ChangeToUpperCase-ZT7En {
	text-transform: uppercase
}

.Cancellation-noBorder-NWK3V {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Cancellation-siteAdminHeading-A0GU1 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Cancellation-siteAdminSubHeading-TQ6Nf {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Cancellation-adminFormDivider-hNMDk {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.Cancellation-space1-IDyrJ {
	margin-bottom: 6px !important;
}

.Cancellation-space2-jqWaS {
	margin-bottom: 12px !important;
}

.Cancellation-space3-xgBvd {
	margin-bottom: 18px !important;
}

.Cancellation-space4-F3zEa {
	margin-bottom: 24px !important;
}

.Cancellation-space5-OQP79 {
	margin-bottom: 30px !important;
}

.Cancellation-space6-K1VSb {
	margin-bottom: 36px !important;
}

.Cancellation-space7-RBOAF {
	margin-bottom: 42px !important;
}

.Cancellation-spaceTop8-Skp50 {
	margin-bottom: 48px !important;
}

.Cancellation-spaceTop1-n9RG8 {
	margin-top: 6px !important;
}

.Cancellation-spaceTop2-l1SBc {
	margin-top: 12px !important;
}

.Cancellation-spaceTop3-rRgmq {
	margin-top: 18px !important;
}

.Cancellation-spaceTop4-AOra7 {
	margin-top: 24px !important;
}

.Cancellation-spaceTop5-X3s5a {
	margin-top: 30px !important;
}

.Cancellation-spaceTop6-NwWDh {
	margin-top: 36px !important;
}

.Cancellation-spaceTop7-U02Dw {
	margin-top: 42px !important;
}

.Cancellation-spaceTop8-Skp50 {
	margin-top: 48px !important;
}

.Cancellation-noMargin-E4JnI {
	margin: 0px !important;
}

.Cancellation-padding1-gcNIR {
	padding-bottom: 6px !important;
}

.Cancellation-padding2-M4iqB {
	padding-bottom: 12px !important;
}

.Cancellation-padding3-yAqQR {
	padding-bottom: 18px !important;
}

.Cancellation-padding4-On2c_ {
	padding-bottom: 24px !important;
}

.Cancellation-padding5-Ifm8t {
	padding-bottom: 30px !important;
}

.Cancellation-padding6-_4_Cf {
	padding-bottom: 36px !important;
}

.Cancellation-padding7-sA_RQ {
	padding-bottom: 42px !important;
}

.Cancellation-paddingTop1-nTdTT {
	padding-top: 6px !important;
}

.Cancellation-paddingTop2-kvJEb {
	padding-top: 12px !important;
}

.Cancellation-paddingTop3-TiLqf {
	padding-top: 18px !important;
}

.Cancellation-paddingTop4-S79Fm {
	padding-top: 24px !important;
}

.Cancellation-paddingTop5-fPeTF {
	padding-top: 30px !important;
}

.Cancellation-paddingTop6-lffrx {
	padding-top: 36px !important;
}

.Cancellation-paddingTop7-NilmG {
	padding-top: 42px !important;
}

.Cancellation-noPadding-bf8q1 {
	padding: 0px !important;
}

.Cancellation-textBold-t3exM {
	font-weight: 500 !important;
}

.Cancellation-textBolder-S1n7O {
	font-weight: 700 !important;
}

.Cancellation-textNormal-KIUZd {
	font-weight: normal !important;
}

.Cancellation-spaceBottom20-b7Knn {
	margin-bottom: 20px;
}

.Cancellation-spaceBottom10-bw2Nc {
	margin-bottom: 10px;
}

.Cancellation-marginNone-cbeXe {
	margin: 0;
}

.Cancellation-spaceBottom15-OejLk {
	margin-bottom: 15px;
}

.Cancellation-marginTopNone-qoXcE {
	margin-top: 0;
}

.Cancellation-spaceTop11-zXtBj {
	margin-top: 11px;
}

.Cancellation-spaceTop21-jfiFV {
	margin-top: 21px;
}

.Cancellation-spaceTop20-fiGYj {
	margin-top: 20px;
}

.Cancellation-spaceTop10-rvzDY {
	margin-top: 10px;
}

/*New Design Text Colors */

.Cancellation-textDarkBlue-owL_U {
	color: rgb(20, 39, 94) !important;
}

.Cancellation-textLightBlue-O8mKE {
	color: rgb(57, 87, 106) !important;
}

.Cancellation-textLightSandleGreen-C0uMz {
	color: rgb(76, 86, 41) !important;
}

.Cancellation-textLightBrown-ltZLB {
	color: rgb(115, 79, 33) !important;
}

.Cancellation-textMediumMaroon-nFWIq {
	color: rgb(87, 37, 51) !important;
}

.Cancellation-textBrown-RKmvZ {
	color: rgb(160, 47, 24) !important;
}

.Cancellation-textMaroon-yeKcy {
	color: rgb(155, 49, 67) !important;
}

.Cancellation-textDarkBrown-vOT90 {
	color: rgb(83, 18, 16) !important;
}

.Cancellation-textMediumBrown-eKVxi {
	color: rgb(142, 28, 10) !important;
}

.Cancellation-textSkyBlue-GRDYu {
	color: rgb(37, 117, 141) !important;
}

.Cancellation-textGray-vcDWl {
	color: rgb(77, 65, 51) !important;
}

.Cancellation-capitalize-fhKD3 {
	text-transform: capitalize;
}

.Cancellation-panelOutline-pz57a {
	border: 1px solid var(--primary-border);
	padding: 24px;
	border-radius: 6px;
}

.Cancellation-tabBtn-RJ2a6 {
	border: 1px solid var(--primary-border);
	border-radius: 25px;
	padding: 12px 24px;
	color: var(--primary-foreground) !important;
	font-size: 16px;
	text-decoration: none !important;
	margin-right: 18px;
	display: inline-block;
	font-weight: 500;
}

.Cancellation-tabBtnActive-Na7uo {
	border: 1px solid var(--primary-foreground);
}

.Cancellation-cancelBlockColor-k2Idy {
	background-color: var(--primary-gray-bg);
	padding: 30px;
	margin-top: 24px;
	border-radius: 6px;
}

@media screen and (max-width: 767px) {
	.Cancellation-cancelBlockColor-k2Idy {
		padding: 15px;
	}

	.Cancellation-textAlignCenterXS-X1iUO {
		text-align: center;
	}

	.Cancellation-tabBtn-RJ2a6 {
		margin-bottom: 10px;
	}

	.Cancellation-panelOutline-pz57a {
		padding: 15px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/routes/siteadmin/cancellation/Cancellation.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;CACC,0BAA0B;AAC3B;;AAEA;CACC,uCAAuC;CACvC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;CACnB,kBAAkB;CAClB,2CAA2C;CAC3C,eAAe;CACf,gCAAgC;CAChC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,wCAAwC;CACxC,aAAa;CACb,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../components/siteadmin/admin-common.css';\n@import '../../../components/helpers.css';\n\n.capitalize {\n\ttext-transform: capitalize;\n}\n\n.panelOutline {\n\tborder: 1px solid var(--primary-border);\n\tpadding: 24px;\n\tborder-radius: 6px;\n}\n\n.tabBtn {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 25px;\n\tpadding: 12px 24px;\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n\tmargin-right: 18px;\n\tdisplay: inline-block;\n\tfont-weight: 500;\n}\n\n.tabBtnActive {\n\tborder: 1px solid var(--primary-foreground);\n}\n\n.cancelBlockColor {\n\tbackground-color: var(--primary-gray-bg);\n\tpadding: 30px;\n\tmargin-top: 24px;\n\tborder-radius: 6px;\n}\n\n@media screen and (max-width: 767px) {\n\t.cancelBlockColor {\n\t\tpadding: 15px;\n\t}\n\n\t.textAlignCenterXS {\n\t\ttext-align: center;\n\t}\n\n\t.tabBtn {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.panelOutline {\n\t\tpadding: 15px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `Cancellation-commonHeaderAdmin-BRlE7`,
	"adminLayout": `Cancellation-adminLayout-At1k2`,
	"box": `Cancellation-box-NWSvC`,
	"exportLink": `Cancellation-exportLink-CHliG`,
	"blockCenter": `Cancellation-blockCenter-g0bU3`,
	"panelHeader": `Cancellation-panelHeader-sGz4H`,
	"currencyselect": `Cancellation-currencyselect-r4AZS`,
	"mar0": `Cancellation-mar0-pP43I`,
	"sideAdminPageWrapper": `Cancellation-sideAdminPageWrapper-xgLgQ`,
	"table": `Cancellation-table-h1PhV`,
	"tableRow": `Cancellation-tableRow-XqG6a`,
	"tableCell": `Cancellation-tableCell-B2c5t`,
	"formGroup": `Cancellation-formGroup-lOzeg`,
	"select": `Cancellation-select-xvvFy`,
	"noMargin": `Cancellation-noMargin-E4JnI`,
	"labelTextNew": `Cancellation-labelTextNew-AcfP0`,
	"displayInline": `Cancellation-displayInline-kaaHb`,
	"btnUPdate": `Cancellation-btnUPdate-a_7Dl`,
	"btnModalDelete": `Cancellation-btnModalDelete-_UqCX`,
	"radioBtn": `Cancellation-radioBtn-TVsOo`,
	"backgroundImg": `Cancellation-backgroundImg-Ef6BG`,
	"btnWidth": `Cancellation-btnWidth-I8hFc`,
	"bannerImageBg": `Cancellation-bannerImageBg-mqyAj`,
	"bannerDelete": `Cancellation-bannerDelete-socLD`,
	"modalRoot": `Cancellation-modalRoot-qdp3u`,
	"modalBorderBottom": `Cancellation-modalBorderBottom-FrUl8`,
	"logInModalBody": `Cancellation-logInModalBody-ue0YO`,
	"exportSection": `Cancellation-exportSection-I54HR`,
	"exportSectionGridSub": `Cancellation-exportSectionGridSub-fXE64`,
	"exportText": `Cancellation-exportText-lDuWp`,
	"exportLinkImg": `Cancellation-exportLinkImg-zPdu6`,
	"vtrMiddle": `Cancellation-vtrMiddle-rDCQU`,
	"exportImg": `Cancellation-exportImg-FsF1V`,
	"profileViewlabel": `Cancellation-profileViewlabel-apfa5`,
	"profileViewMainContent": `Cancellation-profileViewMainContent-oSOVi`,
	"profileViewMain": `Cancellation-profileViewMain-Bnrxd`,
	"profileViewInner": `Cancellation-profileViewInner-KA42s`,
	"profileImageSection": `Cancellation-profileImageSection-SpIRa`,
	"lastviewInner": `Cancellation-lastviewInner-w2m85`,
	"whyHostHoriLine": `Cancellation-whyHostHoriLine-qB146`,
	"tableGrid": `Cancellation-tableGrid-npJYu`,
	"headingContent": `Cancellation-headingContent-STQHo`,
	"refundTextColor": `Cancellation-refundTextColor-vAJkI`,
	"dividerLine": `Cancellation-dividerLine-IhySD`,
	"smallContent": `Cancellation-smallContent-ma_IC`,
	"ChangeToUpperCase": `Cancellation-ChangeToUpperCase-ZT7En`,
	"noBorder": `Cancellation-noBorder-NWK3V`,
	"siteAdminHeading": `Cancellation-siteAdminHeading-A0GU1`,
	"siteAdminSubHeading": `Cancellation-siteAdminSubHeading-TQ6Nf`,
	"adminFormDivider": `Cancellation-adminFormDivider-hNMDk`,
	"space1": `Cancellation-space1-IDyrJ`,
	"space2": `Cancellation-space2-jqWaS`,
	"space3": `Cancellation-space3-xgBvd`,
	"space4": `Cancellation-space4-F3zEa`,
	"space5": `Cancellation-space5-OQP79`,
	"space6": `Cancellation-space6-K1VSb`,
	"space7": `Cancellation-space7-RBOAF`,
	"spaceTop8": `Cancellation-spaceTop8-Skp50`,
	"spaceTop1": `Cancellation-spaceTop1-n9RG8`,
	"spaceTop2": `Cancellation-spaceTop2-l1SBc`,
	"spaceTop3": `Cancellation-spaceTop3-rRgmq`,
	"spaceTop4": `Cancellation-spaceTop4-AOra7`,
	"spaceTop5": `Cancellation-spaceTop5-X3s5a`,
	"spaceTop6": `Cancellation-spaceTop6-NwWDh`,
	"spaceTop7": `Cancellation-spaceTop7-U02Dw`,
	"padding1": `Cancellation-padding1-gcNIR`,
	"padding2": `Cancellation-padding2-M4iqB`,
	"padding3": `Cancellation-padding3-yAqQR`,
	"padding4": `Cancellation-padding4-On2c_`,
	"padding5": `Cancellation-padding5-Ifm8t`,
	"padding6": `Cancellation-padding6-_4_Cf`,
	"padding7": `Cancellation-padding7-sA_RQ`,
	"paddingTop1": `Cancellation-paddingTop1-nTdTT`,
	"paddingTop2": `Cancellation-paddingTop2-kvJEb`,
	"paddingTop3": `Cancellation-paddingTop3-TiLqf`,
	"paddingTop4": `Cancellation-paddingTop4-S79Fm`,
	"paddingTop5": `Cancellation-paddingTop5-fPeTF`,
	"paddingTop6": `Cancellation-paddingTop6-lffrx`,
	"paddingTop7": `Cancellation-paddingTop7-NilmG`,
	"noPadding": `Cancellation-noPadding-bf8q1`,
	"textBold": `Cancellation-textBold-t3exM`,
	"textBolder": `Cancellation-textBolder-S1n7O`,
	"textNormal": `Cancellation-textNormal-KIUZd`,
	"spaceBottom20": `Cancellation-spaceBottom20-b7Knn`,
	"spaceBottom10": `Cancellation-spaceBottom10-bw2Nc`,
	"marginNone": `Cancellation-marginNone-cbeXe`,
	"spaceBottom15": `Cancellation-spaceBottom15-OejLk`,
	"marginTopNone": `Cancellation-marginTopNone-qoXcE`,
	"spaceTop11": `Cancellation-spaceTop11-zXtBj`,
	"spaceTop21": `Cancellation-spaceTop21-jfiFV`,
	"spaceTop20": `Cancellation-spaceTop20-fiGYj`,
	"spaceTop10": `Cancellation-spaceTop10-rvzDY`,
	"textDarkBlue": `Cancellation-textDarkBlue-owL_U`,
	"textLightBlue": `Cancellation-textLightBlue-O8mKE`,
	"textLightSandleGreen": `Cancellation-textLightSandleGreen-C0uMz`,
	"textLightBrown": `Cancellation-textLightBrown-ltZLB`,
	"textMediumMaroon": `Cancellation-textMediumMaroon-nFWIq`,
	"textBrown": `Cancellation-textBrown-RKmvZ`,
	"textMaroon": `Cancellation-textMaroon-yeKcy`,
	"textDarkBrown": `Cancellation-textDarkBrown-vOT90`,
	"textMediumBrown": `Cancellation-textMediumBrown-eKVxi`,
	"textSkyBlue": `Cancellation-textSkyBlue-GRDYu`,
	"textGray": `Cancellation-textGray-vcDWl`,
	"capitalize": `Cancellation-capitalize-fhKD3`,
	"panelOutline": `Cancellation-panelOutline-pz57a`,
	"tabBtn": `Cancellation-tabBtn-RJ2a6`,
	"tabBtnActive": `Cancellation-tabBtnActive-Na7uo`,
	"cancelBlockColor": `Cancellation-cancelBlockColor-k2Idy`,
	"textAlignCenterXS": `Cancellation-textAlignCenterXS-X1iUO`
};
module.exports = ___CSS_LOADER_EXPORT___;
